import {performHttpRequest} from "../http";

export async function getTree() {
    return performHttpRequest(
        window.kaartViewerUrl + '/admin/v2/kaartviewerapi/bookmark/' + window.websiteID + '/tree',
        'GET',
    )
}
